import { render, staticRenderFns } from "./CopyDetailsDesign.vue?vue&type=template&id=356bc1a6"
import script from "./CopyDetailsDesign.vue?vue&type=script&lang=ts"
export * from "./CopyDetailsDesign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports